import useResponsiveDesign from './useResponsiveDesign'
import { useIsPioneerStarterOrGrowth } from './useIsPioneerStarterOrGrowth'
import { useFlipperFlag } from './useFlipperFlag'

export const useIsOnboardingRedesign = () => {
  const location = window.location // eslint-disable-line no-restricted-properties
  const { isMobile } = useResponsiveDesign()
  const planVariant = useIsPioneerStarterOrGrowth()
  const hasContentPlanV2Flag = useFlipperFlag('onboarding_content_plan_v2')

  const isOnRegistration = location.pathname.includes('/signup')
  const isOnLogin = location.pathname.includes('/login')
  const isRegistrationOrLoginPath = isOnRegistration || isOnLogin

  const isPioneerOrLegacyStarter = planVariant === 'pioneer' || (planVariant === 'starter' && !hasContentPlanV2Flag)

  return (
    (!isMobile && (!isPioneerOrLegacyStarter || isRegistrationOrLoginPath)) ||
    (isMobile && isRegistrationOrLoginPath)
  )
}
